import { createRouter,createWebHashHistory } from 'vue-router';
import routes from './routes'
let curVue = null;
let setVue = (vue)=>{
    curVue = vue;
};
const router = createRouter({
    history:createWebHashHistory(),
    routes,
});
let prdtOpen = null
router.beforeEach((to,from,next)=>{
    sessionStorage.setItem('previousPath', from.fullPath)
    let that = curVue.config.globalProperties;
    if(to.meta.type == "KNOW" || to.meta.type == "BPA"){
        if(prdtOpen){
            if(prdtOpen[to.meta.type]){
                next();
            }
            else{
                next('/pub/pswdLogin');
                that.$message({
                    type: 'error',
                    message: '您无权访问',
                })
            }
        }
        else{
            that.$http.post(that.$api.org.orgAuth.isOpenProduct, {
                
            }).then((res)=>{
                if(res.payload && res.payload[to.meta.type]){
                    prdtOpen = res.payload || {}
                    next();
                }
                else{
                    next('/pub/pswdLogin');
                    that.$message({
                        type: 'error',
                        message: '您无权访问',
                    })
                }
            })
        }
    }
    else{
        next();
    }
})
export default {router,setVue};

